module.exports = __webpack_public_path__ + "static/img/13.003de91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/13.png
// module id = lMaR
// module chunks = 0